import ManageContactDrawer from './ManageContactDrawer.component';

export default ManageContactDrawer;
